module.exports = __webpack_public_path__ + "img/gc2.b9bb2179.png";